import { render, staticRenderFns } from "./LpRadioButton.vue?vue&type=template&id=c4152a30&scoped=true"
import script from "./LpRadioButton.vue?vue&type=script&lang=js"
export * from "./LpRadioButton.vue?vue&type=script&lang=js"
import style0 from "./LpRadioButton.vue?vue&type=style&index=0&id=c4152a30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4152a30",
  null
  
)

export default component.exports